import { Pipe, PipeTransform } from '@angular/core';
import { imageCdnUrl } from '../constants/cdn.constants';

@Pipe({ name: 'cdnImage' })
export class CdnImagePipe implements PipeTransform {
  transform(path: string | null | undefined): string {
    if (!path) return '';
    return /^https?:\/\//i.test(path) ? path : imageCdnUrl(path);
  }
}
